import {Component, ErrorHandler, Input, ChangeDetectionStrategy} from '@angular/core';
import {SearchBaseComponent} from '../../../common/search/search.component';
import {FetchService} from '../workflow-services/fetch.service';
import {FetchListData} from '../models/fetch.models';
import {LocalStorage} from '../../../common/storage/local-storage';
import {EnvisiaLocation} from '../../../common/location/envisia-location';
import {Lister} from '../../../common/wrapper.models';

@Component({
    selector: 'fetch-cam-list',
    templateUrl: './fetch-cam-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FetchCamListComponent extends SearchBaseComponent<FetchService, FetchListData> {
  @Input() listData: Lister<FetchListData>;
  protected type = 'fetch_cam_list';

  constructor(protected service: FetchService,
              protected errorHandler: ErrorHandler,
              protected locationService: EnvisiaLocation,
              protected storageService: LocalStorage) {
    super();
  }


}
